import { useMemo } from 'react';
import { useCustomTranslation } from '../../../../../../hooks';
import { KanbanShowOnTaskOption, KanbanShowOnTaskOptions } from '../useProductionPlanSettings.types';
import { useProductionPlanSettings } from '../useProductionPlanSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip } from '@nexelem/components';
import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';

export const KanbanShowOnTask = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');

  const setShowOnTask = useProductionPlanSettings((state) => state.setKanbanShowOnTask);
  const selectedTaskOptions = useProductionPlanSettings((state) =>
    Object.entries(state.kanban.showOnTask)
      .filter(([, value]) => value)
      .map(([key]) => key as KanbanShowOnTaskOption),
  );

  const showOnTaskOptions = useMemo(
    () => [
      {
        label: tWrapper('showOnTaskOptions.salesOrderIdClient'),
        value: KanbanShowOnTaskOptions.SALES_ORDER_ID_CLIENT,
      },
      {
        label: tWrapper('showOnTaskOptions.productionOrderNumber'),
        value: KanbanShowOnTaskOptions.PRODUCTION_ORDER_NUMBER,
      },
      {
        label: tWrapper('showOnTaskOptions.productionOrderExternalNumber'),
        value: KanbanShowOnTaskOptions.PRODUCTION_ORDER_EXTERNAL_NUMBER,
      },
      { label: tWrapper('showOnTaskOptions.time'), value: KanbanShowOnTaskOptions.TIME },
      { label: tWrapper('showOnTaskOptions.assignedWorkers'), value: KanbanShowOnTaskOptions.ASSIGNED_WORKERS },
      { label: tWrapper('showOnTaskOptions.technology'), value: KanbanShowOnTaskOptions.TECHNOLOGY },
      { label: tWrapper('showOnTaskOptions.productionTags'), value: KanbanShowOnTaskOptions.PRODUCTION_TAGS },
    ],
    [tWrapper],
  );

  return (
    <div className="flex flex-col gap-3">
      <label className="text-t14-sb text-text-secondary">{tWrapper('taskContents')}</label>
      <div className="flex flex-wrap gap-x-2 gap-y-3">
        {showOnTaskOptions.map(({ value, label }) => {
          const selected = selectedTaskOptions.includes(value);
          return (
            <Chip
              EndIcon={<FontAwesomeIcon icon={selected ? faCheck : faXmark} />}
              key={value}
              label={label}
              selected={selected}
              onClick={() => setShowOnTask(value)}
            />
          );
        })}
      </div>
    </div>
  );
};
